__webpack_require__.p = "/fecoding-quiz/";